import classNames from 'classnames';
import { FC } from 'react';

import { EventDetailItem } from '@/entities/event';

import styles from './eventTeaList.module.scss';
import EventTeaCard from '../event-tea-card/EventTeaCard';

interface EventTeaListProps {
  event: EventDetailItem;
  className?: string;
}

const EventTeaList: FC<EventTeaListProps> = ({ event, className }) => {
  const items = event.tea_list ?? [];

  if (items.length === 0) {
    return null;
  }

  return (
    <section className={classNames('container', styles.section, className)}>
      <h2 className={styles.section__title}>Дегустируемые чаи</h2>
      <ul className={styles.section__list}>
        {items.map((tea, index) => (
          <li
            key={`${tea.title}-${index}`}
            className={styles.section__list_item}
          >
            <EventTeaCard tea={tea} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default EventTeaList;
